import { stringify } from 'query-string';
import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'TEACHER_CLASSROOMS_GET_ALL',
  GET_ALL_SUCCESS: 'TEACHER_CLASSROOMS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'TEACHER_CLASSROOMS_GET_ALL_FAILURE',
  PATCH: 'TEACHER_CLASSROOMS_PATCH',
  PATCH_SUCCESS: 'TEACHER_CLASSROOMS_PATCH_SUCCESS',
  PATCH_FAILURE: 'TEACHER_CLASSROOMS_PATCH_FAILURE',
};

export const getAll = actions.getAll(
  (teacherId, query) =>
    `${BASE_URL}/teachers/${teacherId}/teacher-classrooms?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const patch = actions.patch(
  teacherClassroomId => `${BASE_URL}/classroom/teacher-classroom/${teacherClassroomId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
